import React, { FunctionComponent } from 'react';
import { connect, DispatchProp } from 'react-redux';
import { IAppState } from 'reducers';
import {
  setAddressesFoundBEnd,
  setAddressNotListedBEnd,
  setDraftPostcodeBEndAction,
  setFullAddressBEndAction,
  setPostcodeBEndAction,
  setOpenreachAddress as setOpenreachAddressAction,
  setAddressRetrieval,
  switchLocationLookup as switchLocationLookupAction,
} from 'Quotes/actions';
import LocationByPostcode from 'Location/LocationByPostcode';
import { IOnNetSite } from 'shared/types/onNetSite';
import { AddressesFound, ILocation } from 'Quotes/types/store';
import { IPAFAddressSite, IOpenReachAddressSite } from 'shared/types/postcodeResults';
import { ProductType } from 'Quotes/types/productTypes';
import { LocationAddressInfo } from 'Location/LocationAddressInfo';
import { LookupIntentSwitcher } from 'Location/LookupIntentSwitcher';
import { IMeta, LocationLookup } from 'Quotes/types/quoteRecordAttributesBase';
import { LocationByALK } from 'Location/LocationByALK';
import { ISetOpenreachAddress } from 'Quotes/types/actions';

export interface IBEndProps {
  addressesFound: AddressesFound;
  addressNotListed: boolean;
  draftPostcode: string;
  postcode: string;
  fullAddress: IPAFAddressSite | IOnNetSite | null;
  referenceAddress: IPAFAddressSite | IOnNetSite | null;
  openreachAddress: IOpenReachAddressSite | null;
  productType?: ProductType | null;
  title?: string;
  quoteMeta: IMeta;
  setAddressesFound(addresses: AddressesFound): void;
  setAddressNotListed(notListed: boolean): void;
  setDraftPostcode(postcode: string): void;
  setFullAddress(address: IPAFAddressSite | IOnNetSite, onNetType?: ILocation['onNetType']): void;
  setPostcode(postcode: string): void;
  setOpenreachAddress(address: ISetOpenreachAddress['payload']['address']): void;
  addressRetrieval(retrieve: boolean, onNetAndPaf: boolean): void;
  switchLocationLookup(lookupType: LocationLookup): void;
}

const BEnd: FunctionComponent<React.PropsWithChildren<IBEndProps>> = ({
  addressesFound,
  addressNotListed,
  addressRetrieval,
  draftPostcode,
  postcode,
  productType,
  fullAddress,
  referenceAddress,
  openreachAddress,
  quoteMeta,
  setAddressesFound,
  setAddressNotListed,
  setDraftPostcode,
  setFullAddress,
  setPostcode,
  setOpenreachAddress,
  switchLocationLookup,
  title,
}) => {
  return (
    <div className="pt-4">
      <h4>{title ? title : 'B-End Location'}</h4>
      <LocationAddressInfo productType={productType!} />
      <LookupIntentSwitcher activeLookupIntent={quoteMeta.b_end_location_lookup} onSwitch={switchLocationLookup} />
      {quoteMeta.b_end_location_lookup !== 'alk' && (
        <LocationByPostcode
          addressRetrieval={addressRetrieval}
          addressesFound={addressesFound}
          addressNotListed={addressNotListed}
          draftPostcode={draftPostcode}
          postcode={postcode}
          productType={productType!}
          selectedAddress={fullAddress}
          referenceAddress={referenceAddress}
          selectedOpenreachAddress={openreachAddress}
          onAddressesFound={setAddressesFound}
          onAddressNotListed={setAddressNotListed}
          onDraftPostcodeChange={setDraftPostcode}
          onPostcodeSubmit={setPostcode}
          onFullAddressSubmit={setFullAddress}
          onOpenreachAddressSubmit={setOpenreachAddress}
        />
      )}
      {quoteMeta.b_end_location_lookup === 'alk' && (
        <LocationByALK
          addressRetrieval={addressRetrieval}
          onALKAddressSubmit={setOpenreachAddress}
          onPostcodeSubmit={setPostcode}
          onDraftPostcodeSubmit={setDraftPostcode}
          selectedOpenreachAddress={openreachAddress}
        />
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch: DispatchProp['dispatch']) => ({
  setAddressNotListed: (notListed: boolean) => dispatch(setAddressNotListedBEnd(notListed)),
  setAddressesFound: (addresses: AddressesFound) => dispatch(setAddressesFoundBEnd(addresses)),
  setDraftPostcode: (postcode: string) => dispatch(setDraftPostcodeBEndAction(postcode)),
  setFullAddress: (fullAddress: IPAFAddressSite | IOnNetSite, onNetType?: ILocation['onNetType']) =>
    dispatch(setFullAddressBEndAction(fullAddress, onNetType)),
  setPostcode: (postcode: string) => dispatch(setPostcodeBEndAction(postcode)),
  setOpenreachAddress: (address: ISetOpenreachAddress['payload']['address']) =>
    dispatch(setOpenreachAddressAction('B', address)),
  addressRetrieval: (retrieve: boolean, onNetAndPaf: boolean) =>
    dispatch(setAddressRetrieval(false, onNetAndPaf, retrieve)),
  switchLocationLookup: (lookupType: LocationLookup) => dispatch(switchLocationLookupAction('B', lookupType)),
});

const mapStateToProps = (state: IAppState) => ({
  addressNotListed: state.quoteBuilder.quoteEndpointMeta.b_end_address_not_listed || false,
  addressesFound: state.quoteBuilder.quote.location.bEnd.addressesFound,
  draftPostcode: state.quoteBuilder.quote.location.bEnd.draftPostcode,
  postcode: state.quoteBuilder.quote.location.bEnd.postcode,
  fullAddress: state.quoteBuilder.quote.location.bEnd.fullAddress,
  referenceAddress: state.quoteBuilder.quote.location.aEnd.fullAddress,
  openreachAddress: state.quoteBuilder.quote.location.bEnd.openreachAddress,
  productType: state.quoteBuilder.quote.productType,
  quoteMeta: state.quoteBuilder.quoteEndpointMeta,
});

export { BEnd };
export default connect(mapStateToProps, mapDispatchToProps)(BEnd);
